<template>
  <div class="tab-item">
    <base-info-one :subBaseData="baseDataOne"></base-info-one>
    <base-info-finance ref="baseDataFinance"></base-info-finance>
    <base-info-two :subBaseData="baseDataTwo"></base-info-two>
  </div>
</template>

<script>
  import baseInfoOne from "@/components/pageDtl/baseInfoOne";
  import baseInfoFinance from "@/components/pageDtl/baseInfoFinance";
  import baseInfoTwo from "@/components/pageDtl/baseInfoTwo";
  export default {
    name: "baseInfo",
    components: {
      baseInfoOne,
      baseInfoFinance,
      baseInfoTwo
    },
    props:{
      baseDataOne:{  // baseData
        type: Object,
      },
      baseDataFinance:{
        type: Object,
      },
      baseDataTwo:{  // baseData
        type: Object,
      },
    },
    data(){
      return{
        // dataObj:this.baseDataOne,
      }
    },
    watch:{
      // baseData(val){
      //   let _this = this;
      //   _this.dataObj = val;
      // }
    },
    created() {

    },
    mounted() {
      this.$nextTick(()=>{
        this.$refs.baseDataFinance.handleInit(this.baseDataFinance);
      })

    }
  }
</script>

<style lang="scss" scoped>

</style>
